/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'vs-snat-ip-addresses';
const prefix = `${moduleName}.${componentName}`;

export const snatIpAddressLabel = `${prefix}.snatIpAddressLabel`;
export const bothLabel = `${prefix}.bothLabel`;

export const ENGLISH = {
    [snatIpAddressLabel]: 'SNAT Addresses',
    [bothLabel]: 'Both',
};
